import { Box, Grid2, FormControl, Select, MenuItem, Typography, Pagination, Snackbar, Alert, Badge } from '@mui/material'
import { Page_Padding, Constants } from '../../shared/constants'
import CustomDivider from '../../shared/utils/CustomDivider'
import { useMemo, useState, useEffect } from 'react'
import SkillBoxProductCard from '../../shared/components/SkillBoxProductCard'
import { useSkillBoxProducts, useSkillProductCategory } from '../../assets/api/useGetApi'
import SkillBoxSearchBar from '../SkillBox/SkillBoxSearchBar'
import { Icon } from '@iconify/react/dist/iconify.js'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSkillBoxCart } from '../../assets/nodeApi/getApi/getCommonApi'

const SkillBoxAllProducts = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const sourcePath = location.pathname;
    const sourceName = "Skill Box";

    const [searchKeyword, setSearchKeyword] = useState("");
    const [selectedCategoryId, setSelectedCategoryId] = useState("");
    const [page, setPage] = useState(1);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const { data: categoryData } = useSkillProductCategory();
    const { data: cartData } = useSkillBoxCart();
    const categories = useMemo(() => categoryData?.data?.length > 0 ? categoryData.data : [], [categoryData?.data]);

    const checkAuth = () => {
        try {
            const authStorage = JSON.parse(localStorage.getItem('auth-storage'));
            return !!authStorage?.state?.accessToken;
        } catch (e) {
            console.error("Error reading auth storage", e);
            return false;
        }
    };

    useEffect(() => {
        if (categories.length > 0 && !selectedCategoryId) {
            setSelectedCategoryId(categories[0].id);
        }
    }, [categories, selectedCategoryId]);

    const { data: skillBoxData, isLoading: isSkillBoxLoading } = useSkillBoxProducts(selectedCategoryId, page);

    const sourceData = skillBoxData?.data?.length > 0 ? skillBoxData.data : [];

    const skillBoxProducts = useMemo(() => {
        return sourceData.map((p) => ({
            ...p,
            course_name: p.course_name || p.title,
            image_small: p.image_small || p.image,
        }));
    }, [sourceData]);

    const productList = useMemo(() => {
        if (!searchKeyword?.trim()) return skillBoxProducts;
        return skillBoxProducts.filter((item) =>
            item?.course_name?.toLowerCase()?.includes(searchKeyword?.trim()?.toLowerCase())
        );
    }, [skillBoxProducts, searchKeyword]);

    return (
        <Box className="body contact_us" px={Page_Padding} sx={{ maxWidth: '1536px', mx: 'auto', pb: '4rem' }}>

            <Box
                component="img"
                src={Constants.customImages.SkillBoxImg}
                alt="Classroom activity"
                sx={{
                    width: '100%',
                    objectFit: "cover",
                    my: '2rem'
                }}
            />
            {/* ── Product List ── */}
            <Box
                sx={{
                    width: "100%",
                    pt: "1rem",
                }}
            >
                <Grid2 container spacing={"1rem"} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                        <SkillBoxSearchBar
                            options={skillBoxProducts.map((c) => ({
                                id: c?.course_name,
                                label: c?.course_name,
                            }))}
                            onSearch={(keyword) => setSearchKeyword(keyword || "")}
                            placeholder="Search for products"
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6, sm: 4, md: 4 }}>
                        <FormControl fullWidth size="small" >
                            <Select
                                value={selectedCategoryId || ""}
                                onChange={(e) => {
                                    setSelectedCategoryId(e.target.value);
                                    setPage(1);
                                }}
                                displayEmpty
                                sx={{
                                    borderRadius: "12px",
                                    backgroundColor: "#fff",
                                    fontFamily: "'Poppins', sans-serif",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "1px solid #E2002B70"
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#E2002B70"
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#E2002B70",
                                        borderWidth: "1px"
                                    }
                                }}
                            >
                                {categories.map((cat) => (
                                    <MenuItem key={cat.id} value={cat.id}>
                                        {cat.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid2>
                    <Grid2 size={{ xs: 6, sm: 2, md: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "1.2rem", height: "100%" }}>
                            <Icon icon="mingcute:heart-fill" width={24} height={24} color='red' style={{ cursor: "pointer" }} onClick={() => {
                                if (checkAuth()) {
                                    navigate('/Wishlist', { state: { sourcePath, sourceName } });
                                } else {
                                    setSnackbarOpen(true);
                                }
                            }} />
                            <Badge
                                badgeContent={checkAuth() ? (cartData?.data?.length || 0) : 0}
                                color="error"
                                sx={{
                                    '& .MuiBadge-badge': {
                                        bgcolor: 'red.main',
                                        color: '#fff',
                                        fontSize: '10px',
                                        fontWeight: 500,
                                        height: '16px',
                                        minWidth: '16px',
                                        padding: '0'
                                    }
                                }}
                            >
                                <Icon icon="ion:cart-outline" width={24} height={24} color='#777' style={{ cursor: "pointer" }} onClick={() => {
                                    if (checkAuth()) {
                                        navigate('/Cartpage', { state: { sourcePath, sourceName } });
                                    } else {
                                        setSnackbarOpen(true);
                                    }
                                }} />
                            </Badge>
                        </Box>
                    </Grid2>
                </Grid2>

                <Grid2 container spacing={{ xs: "1rem", md: "2rem" }} sx={{ paddingTop: "20px" }}>
                    {
                        productList.map((item, index) => (
                            <Grid2 size={{ xs: 6, sm: 4, md: 3, lg: 3 }} key={item?.slug || index}>
                                <SkillBoxProductCard item={item} />
                            </Grid2>
                        ))
                    }
                    {
                        productList.length === 0 && (
                            <Grid2 size={{ xs: 12, sm: 12, md: 12 }} sx={{ textAlign: "center", marginTop: "20px" }}>
                                <Icon
                                    icon="ant-design:product-outlined"
                                    width="54"
                                    height="54"
                                    color="#999"
                                    style={{ flexShrink: 0 }}
                                />
                                <Typography variant='body1'>No products found</Typography>
                            </Grid2>
                        )
                    }
                </Grid2>

                {
                    (skillBoxData?.pagination?.pages > 1 && productList.length > 0) && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                            <Pagination
                                count={skillBoxData?.pagination?.pages}
                                page={page}
                                onChange={(e, value) => setPage(value)}
                                color="primary"
                                siblingCount={1}
                                boundaryCount={0}
                                sx={{
                                    '& .MuiPaginationItem-ellipsis': {
                                        display: 'none'
                                    }
                                }}
                            />
                        </Box>
                    )
                }

            </Box>
            <CustomDivider />

            <Snackbar 
                open={snackbarOpen} 
                autoHideDuration={4000} 
                onClose={() => setSnackbarOpen(false)} 
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity="info" sx={{ width: '100%' }}>
                    Please login and buy products or add your favorite items to wishlist
                </Alert>
            </Snackbar>

        </Box>
    );
};

export default SkillBoxAllProducts;
